import React, { useState } from 'react';
import { toast } from 'sonner';

const Contact = () => {
  const [form, setForm] = useState({ first: '', last: '', phone: '', email: '', message: '' });
  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    if (!form.email || !form.first) {
      toast.error('Please fill in the required fields.');
      return;
    }
    toast.success('Message sent! We\'ll be in touch soon.');
    setForm({ first: '', last: '', phone: '', email: '', message: '' });
  };

  return (
    <main style={{ backgroundColor: '#F5EDE0' }}>
      <div className="max-w-[720px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <h1 className="font-serif text-[40px] md:text-[52px] mb-8" style={{ color: '#2D5A3D' }}>
          Contact
        </h1>
        <p className="text-[15px] mb-10 leading-relaxed" style={{ color: '#2D5A3D' }}>
          Questions about your scalp, your order, or anything else? Drop us a note — we read every message.
        </p>
        <form onSubmit={submit} className="space-y-5">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <Field label="First name" value={form.first} onChange={onChange('first')} required />
            <Field label="Last name" value={form.last} onChange={onChange('last')} />
            <Field label="Phone" value={form.phone} onChange={onChange('phone')} type="tel" />
            <Field label="Email" value={form.email} onChange={onChange('email')} type="email" required />
          </div>
          <div>
            <label className="block text-[12px] uppercase tracking-[0.18em] mb-2" style={{ color: '#2D5A3D' }}>
              Message
            </label>
            <textarea
              value={form.message}
              onChange={onChange('message')}
              rows={5}
              className="w-full bg-white border rounded-lg px-4 py-3 text-[14px] focus:outline-none focus:ring-1"
              style={{ borderColor: 'rgba(45,90,61,0.3)', color: '#2D5A3D' }}
            />
          </div>
          <button
            type="submit"
            className="px-8 py-4 rounded-full text-[13px] uppercase tracking-[0.22em] font-medium btn-hover"
            style={{ backgroundColor: '#2D5A3D', color: '#F5EDDF' }}
          >
            Send
          </button>
        </form>
      </div>
    </main>
  );
};

const Field = ({ label, value, onChange, required, type = 'text' }) => (
  <div>
    <label className="block text-[12px] uppercase tracking-[0.18em] mb-2" style={{ color: '#2D5A3D' }}>
      {label}{required && ' *'}
    </label>
    <input
      type={type}
      value={value}
      onChange={onChange}
      required={required}
      className="w-full bg-white border rounded-lg px-4 py-3 text-[14px] focus:outline-none focus:ring-1"
      style={{ borderColor: 'rgba(45,90,61,0.3)', color: '#2D5A3D' }}
    />
  </div>
);

export default Contact;
